import { DateTime } from 'luxon';

/**
 * Removes offset from JS date.
 * For example if provided date time is 2023-03-14T13:08:29+02:00,
 * the returned value is 2023-03-14T13:08:29+00:00
 *
 * @export
 * @param {Date} date Input local date time.
 * @return {DateTime}  UTC date time.
 */
export function removeJSDateLocalOffset(date: Date): DateTime {
    return DateTime.fromJSDate(date).toUTC().minus({ minutes: date.getTimezoneOffset() });
}
